module.exports = __webpack_public_path__ + "a48104c89a1eccaabb00a772df844278.svg";